/** これ以上の日付本数でも X には最大この本数まで（端と均等な中間） */
const FIT_LONG_SPAN_MAX_TICK_LABELS = 7;

import { BAR_CHART_WIDTH_MENU_THRESHOLD } from '@/features/charts/useBarChartScrollContainer';

/** メニュー閾値と同じ日数。以下なら短い系列として X を最大 4 本程度で均等間隔にする */
export const FIT_X_AXIS_SHORT_SPACING_UNDER_DAY_COUNT = BAR_CHART_WIDTH_MENU_THRESHOLD;

/** 7 日以下系列で X に出す目安の上限（両端を含む均等間隔） */
const FIT_SHORT_SPAN_MAX_TICK_LABELS = 4;

/**
 * 全体表示（fit）および「7日以下」系列の X に出すインデックス。
 * 先頭・末尾を優先し、その間を均等に取った位置（長系列は最大 FIT_LONG_SPAN_MAX_TICK_LABELS 本、7日以下は最大 FIT_SHORT_SPAN_MAX_TICK_LABELS 本）。
 */
export function fitModeXAxisTickIndexSet(labelCount: number): Set<number> {
    if (labelCount <= 0) return new Set();
    if (labelCount === 1) return new Set([0]);

    if (labelCount > BAR_CHART_WIDTH_MENU_THRESHOLD) {
        const idx = new Set<number>();
        idx.add(0);
        idx.add(labelCount - 1);
        const interior = FIT_LONG_SPAN_MAX_TICK_LABELS - 2;
        for (let k = 1; k <= interior; k++) {
            const i = Math.round((k * (labelCount - 1)) / (interior + 1));
            idx.add(Math.min(labelCount - 1, Math.max(0, i)));
        }
        return idx;
    }

    const span = labelCount - 1;
    const slots = Math.min(labelCount, FIT_SHORT_SPAN_MAX_TICK_LABELS);
    const idx = new Set<number>();
    if (slots <= 1) {
        idx.add(0);
        return idx;
    }
    for (let j = 0; j < slots; j++) {
        const i = Math.round((j * span) / (slots - 1));
        idx.add(Math.min(span, Math.max(0, i)));
    }
    return idx;
}
